import RichText from "$lib/components/RichText.svelte";
import { getYoutubeThumbnailUrl, extractYoutubeVideoID } from "$lib/utilities/components/embeds";
import { buildSrc, srcSetFromWidths, sizesForBreakpoints, SRCSET_WIDTHS } from "$lib/utilities";

export const mapAccordionItems = (items) =>
  items.map((item) => ({
    headline: item.fields.headline,
    body: RichText,
    bodyProps: {
      node: item.fields.body
    },
    active: item.fields.expandedOnLoad
  }));

export const mapListQA = (items) =>
  items.map((item) => ({
    question: item.fields.headline,
    answer: {
      body: RichText,
      bodyProps: {
        node: item.fields.body
      }
    }
  }));

const LIST_THUMBNAIL_IMAGE_SIZES = sizesForBreakpoints({
  sm: "50vw",
  md: "25vw",
  lg: "167px",
  xl: "240px"
});

export const mapListItems = (items) => {
  let resizeParams = {};

  return items.map((item) => {
    if (item.sys.contentType.sys.id === "contentGroupItem") {
      const image = item.fields.image?.fields;

      return {
        headline: item.fields.headline,
        subtitle: item.fields.subtitle,
        component: RichText,
        image: image
          ? {
              alt: image?.imageAsset?.fields?.alt || "",
              src: buildSrc(image?.imageAsset),
              srcset: srcSetFromWidths(
                image?.imageAsset?.fields?.file?.url,
                SRCSET_WIDTHS,
                resizeParams
              ),
              sizes: LIST_THUMBNAIL_IMAGE_SIZES
            }
          : undefined,
        componentProps: {
          node: item.fields.body
        }
      };
    } else if (item.sys.contentType.sys.id === "embed") {
      return {
        title: item.fields.title,
        displayTitle: item.fields.displayTitle,
        source: item.fields.source,
        url: item.fields.url,
        embedID: item.fields.embedID,
        contentType: item.sys.contentType.sys.id
      };
    } else {
      return {
        headline: item.fields.headline
      };
    }
  });
};

export const mapTimeline = (items) => {
  const result = [];
  // Start index at -1 to create no accordions
  let currentAccordionIndex = -1;
  let lastTimeRecorded = null;
  items.forEach((item) => {
    const event = {
      headline: item.fields.headline,
      subtitle: item.fields.subtitle,
      body: RichText,
      bodyProps: {
        node: item.fields.body
      },
      active: item.fields.expandedOnLoad
    };
    const currentTime = item.fields.time;
    // Components that have a different time than the previous create an accordion
    if ((currentTime && currentTime !== lastTimeRecorded) || currentAccordionIndex === -1) {
      // Creates new accordion
      currentAccordionIndex++;
      lastTimeRecorded = currentTime;
      result[currentAccordionIndex] = { datetime: currentTime, events: [] };
    }
    // Push event to current accordion
    result[currentAccordionIndex].events.push(event);
  });

  return result;
};

export const mapVideoPlaylistItems = (data) => {
  return data.map((item) => {
    const defaultThumbnail = getYoutubeThumbnailUrl(item.fields?.url);

    return {
      header: item.fields.title,
      body: item.fields.description,
      videoCoverImage: defaultThumbnail
        ? {
            src: defaultThumbnail,
            alt: ""
          }
        : undefined,
      videoId: extractYoutubeVideoID(item.fields?.url)
    };
  });
};
